import * as React from "react";
import { useTranslation } from "react-i18next";
import { IDistributorInfo } from "../shared/RestApi";

type Props = {
  distributorInfo: IDistributorInfo;
};

export function HowManyLicencesHaveYouMessage({ distributorInfo }: Props) {
  const { t } = useTranslation();

  return (
    <div>
      <p>
        {t("licenses.boughtAndSent", {
          bought: distributorInfo.LicensesBought,
          sent:
            distributorInfo.LicensesBought - distributorInfo.AvailableLicenses,
        })}
      </p>
    </div>
  );
}
